import { render } from "./paymethod.vue?vue&type=template&id=1791df8c&scoped=true"
import script from "./paymethod.vue?vue&type=script&lang=js"
export * from "./paymethod.vue?vue&type=script&lang=js"

import "./paymethod.vue?vue&type=style&index=0&id=1791df8c&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1791df8c"]])

export default __exports__